import { Collapse as AntDCollapse } from "antd";
import styled from "styled-components";
import { lightText, primaryColor } from "./Utilities.styled";

const Collapse = styled(AntDCollapse)`
  max-width: 120rem;

  .ant-collapse-header {
    width: 120rem;
    max-width: 95vw;
    margin-bottom: 1rem;
  }
  .ant-collapse-expand-icon {
    color: ${lightText};
  }
`;

const Highlights = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding-left: 2rem;
  color: ${lightText};
  font-size: 1.6rem;
  line-height: 1.6;

  li::marker {
    color: ${primaryColor};
  }
`;

export { Collapse, Highlights };
